import React from 'react';
import SocialLinks from '../socialids/socialLinks';

const Contact = () => (
  <section id="contact" className="py-16 text-center bg-pink-50">
    <h2 className="text-3xl font-semibold text-purple-800 mb-8">Contact Us</h2>
    <SocialLinks />
    <div className="max-w-2xl mx-auto">
      <form className="space-y-4">
        <div>
          <label htmlFor="name" className="block text-left text-purple-800 font-semibold mb-2">Name</label>
          <input type="text" id="name" name="name" className="w-full border border-pink-200 rounded-lg p-2" placeholder="Your Name" />
        </div>
        <div>
          <label htmlFor="email" className="block text-left text-purple-800 font-semibold mb-2">Email</label>
          <input type="email" id="email" name="email" className="w-full border border-pink-200 rounded-lg p-2" placeholder="Your Email" />
        </div>
        <div>
          <label htmlFor="message" className="block text-left text-purple-800 font-semibold mb-2">Message</label>
          <textarea id="message" name="message" className="w-full border border-pink-200 rounded-lg p-2" rows="4" placeholder="Your Message"></textarea>
        </div>
        <button type="submit" className="bg-purple-800 text-white px-4 py-2 rounded-lg hover:bg-purple-700">Send Message</button>
      </form>
    </div>
  </section>
);

export default Contact;